// extracted by mini-css-extract-plugin
export var borderRadius = "_a6-4";
export var large = "_a6-3";
export var logoContainer = "_a6-0";
export var nameLogo = "_a6-2";
export var small = "_a6-1";